import styleVariables from '@/assets/scss/variables.module.scss';
import { SprintState } from '@/types/sprint';

export default function useSprintStateIcon() {
  const sprintStateIcon = (state: string) => {
    switch (state) {
      case SprintState.Active:
        return { icon: 'sprint-current', color: styleVariables.primary500 };
      case SprintState.Completed:
        return { icon: 'sprint-completed', color: 'var(--placeholderIcon)' };
      case SprintState.Canceled:
        return { icon: 'sprint-cancelled', color: styleVariables.warning500 };
      default:
        return { icon: 'sprint-future', color: 'var(--iconDefault)' };
    }
  };

  return {
    sprintStateIcon,
  };
}
